<template>
    <div class="tr mp-promos__product">
        <div
            class="mp-promos__productWrapper"
            :id="`mp-promos__productWrapper-${product.dict_product.id}`"
        >
            <div class="tr__upper mp-labels__products">
                <div class="tr__primary">
                    <div class="tr-featured">
                        <div class="c-fig c-fig--promos">
                            <img
                                class="c-fig__img"
                                :src="product.dict_product.image.urls.small"
                                alt
                            />
                        </div>
                        <div class="tr-featured__details">
                            <span class="typo typo--label"
                                >EAN: {{ product.ean }}</span
                            >
                            <h6 class="typo typo--name">
                                {{ product.dict_product.name }}
                            </h6>
                        </div>
                    </div>
                </div>
                <slot name="showMoreBtn"></slot>
            </div>
        </div>
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
        product: {
            type: Object,
            required: true
        }
    }
}
</script>
